export default function CsharpForeachArrays() {
  return (
    <h2>Csharp Foreach Arrays</h2>
  );
}
